import { ROLE_TYPES } from 'utils/permissions';

export const AVERAGE_SALARIES_PERMISSIONS = {
  averageSalaries: [ROLE_TYPES.ceo, ROLE_TYPES.finance_specialist],
};
